<template>
  <div class="title-box" v-if="isShowFieldTitle(moduleData) && moduleData.componentList.length">
    <span class="title">{{ moduleData.title }}</span>
    <div class="btn-box" v-if="showBtnList.length">
      <template v-for="(item, index) in showBtnList" :key="index">
        <RxkButton style="margin-left: 8px" v-if="item.show" @click="handleBtnClick(item)">
          {{ item.title }}
        </RxkButton>
      </template>
      <el-dropdown v-if="moreBtnList.length">
        <RxkButton style="margin-left: 8px">更多</RxkButton>
        <template #dropdown>
          <el-dropdown-menu>
            <template v-for="(item, index) in moreBtnList">
              <el-dropdown-item v-if="item.show" :key="index" @click="handleBtnClick(item)">
                {{ item.title }}
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
  <ul :class="['col-form-item-ul', select ? `flex-col-${select}` : '']">
    <template v-for="(item, index) in moduleData.componentList" :key="index">
      <li
        class="col-item"
        v-if="item.show"
        :class="[item.layout ? `col-${item.layout.proportion}` : '']"
      >
        <el-form-item
          :label="
            item.columnInfo.name + (item.columnInfo.desc ? '(' + item.columnInfo.desc + ')' : '')
          "
          :rules="getRules(item)"
          :key="item.columnInfo.id"
          :prop="item.fieldCode"
        >
          <div class="val">
            <Render
              :sceneType="SceneTypeEnum.ADD_FORM"
              :data="item"
              :fieldCode="item.fieldCode"
              ref="renderRef"
              :comp-name="item.renderConfig.compName"
              :renderConfig="item.renderConfig"
              :shopOrderId="shopOrderId"
              :quoteMappingConfig="quoteMappingConfig"
              :value="getValue(item, form)"
              @changeValue="value => changeValue(value, item, form)"
              @refreshDataList="value => refreshDataList(value, item)"
              @blur="value => handleBlur(value, item, form)"
              :positions="positions"
              :isTxt="false"
              :formData="formData"
              :quoteDataIdList="quoteDataIdList"
              :quoteTableCode="quoteTableCode"
            />
          </div>
        </el-form-item>
      </li>
    </template>
  </ul>
  <AddForm
    v-if="addVisible"
    :tableCode="btnData.actionValue"
    @addSuccess="addSuccess"
    v-model:visible="addVisible"
    :formData="btnFormData"
    quoteTableCode="9c99f25a97f34da4858ea60c8adb8d"
    :quoteDataIdList="quoteDataIdListData"
  />
</template>
<script setup lang="ts">
import type { PropType } from 'vue'
import Render from '@/components/custom/form/components/render.vue'
import { computed, inject, watch, ref, onMounted } from 'vue'
import {
  dealFormValConfig,
  ruleStrategy,
  isQuote,
  isMapping,
  findFieldBySource
} from '@/utils/preObjectManage/utils'
import { fieldTypeConfig, fieldTypeEnum, operateListEnum } from '@/enums/preObjectManage'
import { isString, isEmpty, isNullOrUndefOrEmpty } from '@/utils/is'
import { AddForm } from '@/components/business/addForm'
import { formulaEmitter } from '@/utils/business/formulaEmitter'
import { formatToDate, formatToDateTime } from '@/utils/date'
import { findField } from '@/utils/preObjectManage/utils'
import { useAccountStore } from '@/stores/modules/account'
import { SceneTypeEnum } from '@/enums/business'

const accountStore = useAccountStore()

const props = defineProps({
  select: {
    type: Number,
    default: 1
  },
  moduleData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  formData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  positions: {
    type: Array as PropType<Recordable[]>,
    default: () => []
  },
  quoteMappingConfig: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  quoteDataIdList: {
    type: Array as PropType<Recordable[]>,
    default: () => []
  },
  quoteTableCode: {
    type: String,
    default: ''
  }
})
const emits = defineEmits(['blur'])
const quoteDataIdListData = ref(['1228724547717378048'])
const form = computed(() => {
  return props.formData
})
const associaFormCondition = inject('associaFormCondition') as Recordable[]
const formDataRef = inject('formDataRef') as Recordable
const refreshVisible = inject('refreshVisible') as Fn
const equationList = inject('equationList') as Recordable[]
// 获取值
function getValue(data: Recordable, form: Recordable) {
  const { code, fieldCode, fieldType } = data
  let customCode = code
  // 引用字段
  if (
    fieldType === fieldTypeEnum.SYS_QUOTE ||
    fieldType === fieldTypeEnum.CUSTOM_QUOTE ||
    fieldType === fieldTypeEnum.SON_SYS_QUOTE ||
    fieldType === fieldTypeEnum.SON_CUSTOM_QUOTE
  ) {
    customCode = fieldTypeConfig.quote
  }
  // 映射字段
  if (
    fieldType === fieldTypeEnum.SYS_MAPPING ||
    fieldType === fieldTypeEnum.CUSTOM_MAPPING ||
    fieldType === fieldTypeEnum.SON_SYS_MAPPING ||
    fieldType === fieldTypeEnum.SON_CUSTOM_MAPPING
  ) {
    customCode = fieldTypeConfig.mapping
  }

  const getValueFn = dealFormValConfig[customCode]
    ? dealFormValConfig[customCode].getValue
    : () => form[fieldCode] || ''

  // 只要是数字，金额，百分比就去触发
  if (
    code === fieldTypeConfig.number ||
    code === fieldTypeConfig.money ||
    code === fieldTypeConfig.percentage
  ) {
    formulaEmitter(
      unref(equationList),
      data,
      getValueFn(data, form),
      props?.moduleData?.componentList
    )
  }

  return getValueFn(data, form)
}

const shopOrderId = ref('')
// 修改表单的值
function changeValue(value: any, data: Recordable, form: Recordable) {
  const { code, fieldCode, fieldType } = data
  console.log(value, 'juhua11', data)
  let customCode = code
  // 引用字段
  if (isQuote(fieldType)) {
    customCode = fieldTypeConfig.quote
  }
  // 映射字段
  if (isMapping(fieldType)) {
    customCode = fieldTypeConfig.mapping
  }
  const setValueFn = dealFormValConfig[customCode]
    ? dealFormValConfig[customCode].setValue
    : () => {
        form[fieldCode] = value
      }
  setValueFn(value, data, form)
  // 如果是单选下拉或者单选按钮
  if (code === fieldTypeConfig.radio || code === fieldTypeConfig.select) {
    refreshVisible(data, value)
  }

  // 特殊处理 转介绍人
  if (data.fieldSerial === '5265168601281897000') {
    nextTick(() => {
      shopOrderId.value = data.renderConfig.id
    })
    // 客户名称改变 清空转介绍人 和来源
    const personCode = findField(props.positions, '1768199252922068992')?.fieldCode
    const personSourceCode = findField(props.positions, '1768199253416996864')?.fieldCode
    form[personCode] = ''
    form[personSourceCode] = ''
  }
  if (unref(associaFormCondition).length) {
    unref(associaFormCondition).forEach(item => {
      const cur = item.columnSerials.find(serial => serial === data.fieldSerial)
      if (cur) {
        item.Emitter.emit('associaForm', item.moduleSerial)
      }
    })
  }
}
function handleBlur(value: any, data: Recordable, form: Recordable) {
  // 如果此时编辑了联系人电话，需要看是否有主要联系人电话字段，如果有，如果主要联系人电话的值为空，就将联系人电话的值赋值给主要联系人电话，反之亦然
  if (['1743166786575980925', '1743169784381956096'].includes(data.fieldSerial)) {
    const fieldMap: { [key: string]: string } = {
      '1743169784381956096': '1743166786575980925', // 联系人电话：主要联系人电话
      '1743166786575980925': '1743169784381956096' // 主要联系人电话：联系人电话
    }
    const targetFieldCode = findField(props.positions, fieldMap[data.fieldSerial])?.fieldCode // 如果没有配置字段显示就会返回undefined
    if (!isNullOrUndefOrEmpty(targetFieldCode) && isNullOrUndefOrEmpty(form[targetFieldCode])) {
      form[targetFieldCode] = value
      formDataRef.value?.validateField(targetFieldCode)
    }
  }
  emits('blur', data, form[data.fieldCode])
}
watch(
  () => props?.moduleData,
  val => {
    console.log('监听结构', val)
  }
)
function refreshDataList(value: any, item: Recordable) {
  item.dataList = value
  item.renderConfig.dataList = value
}

// 当前字段是否必填

// 获取验证规则
function getRules(item: Recordable) {
  let res: Recordable[] = []
  const requiredRule = {
    required: true,
    message: `${item.name}必填`,
    trigger: [
      fieldTypeConfig.department,
      fieldTypeConfig.personMultiple,
      fieldTypeConfig.select,
      fieldTypeConfig.singleLineText,
      fieldTypeConfig.phone,
      fieldTypeConfig.picture,
      fieldTypeConfig.person
    ].includes(item.fieldProperty)
      ? 'change'
      : 'blur'
  }
  res = res.concat(getSpecialRules(item))
  // 必填
  const current = item.columnOperateList.find((operate: Recordable) => {
    return operate.value && operate.code === operateListEnum.MUST
  })
  // 必填就放到规则中去
  current && res.push(requiredRule)

  const otherRule = ruleStrategy[item.code]
  if (!isQuote(item.fieldType) && !isMapping(item.fieldType) && otherRule) {
    // 引用与映射时不用验证其具体的值(因为都是传的id),只验证其是否必填
    const tempRuleObj = otherRule(item)
    if (tempRuleObj) {
      res.push(otherRule(item))
    }
  }
  // 多选图片的验证单独拆出来
  // if (!item.writeFlag && item.fieldProperty === fieldTypeConfig.multiple_picture) {
  //   return []
  // }
  // if (item.validFlag === 1) { // 是否需要接口校验的标志
  //   // 目前自增编号是统一的, 当validFlag为1需要失焦验证其唯一性,如果后期修改根据业务来的话,则通过自定义验证在具体业务添加
  //   // if (item.fieldProperty === fieldTypeConfig.incrementNumber) {
  //   //   res.push(createIncrementNumberValidRule({
  //   //     field: item, isEdit: this.isEdit, data: this.data
  //   //   }))
  //   // }
  //   // 这个是以前写死的字段验证重复的,可能有影响到其他的业务
  //   res.push(createRequestValidRule({
  //     field: item, isEdit: this.isEdit, data: this.data
  //   }))
  // }
  // 对应于预定义的特殊验证情况 todo 看后期需要自己加特殊字段定义不,目前先去掉
  // if (item.validator) {
  //   res.push(item.validator)
  // }
  return res
}

function getSpecialRules(item: Recordable): Recordable[] {
  let ruleList = []
  /** 长度校验 */
  // 输入最大长度
  if (!isNaN(+item.maxLength) && +item.maxLength > 0) {
    ruleList.push({
      validator: (rule: any, value: any, callback: any) => {
        if (!value) {
          callback()
        } else if (value.length > +item.maxLength) {
          callback(new Error(`${item.name}最多输入${item.maxLength}位`))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    })
  }
  // 输入最小长度
  if (!isNaN(+item.minLength) && +item.minLength > 0) {
    ruleList.push({
      validator: (rule: any, value: any, callback: any) => {
        if (!value) {
          callback()
        } else if (value.length < +item.minLength) {
          callback(new Error(`${item.name}最少输入${item.minLength}位`))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    })
  }
  /** 数值校验 */
  // 数字 输入最大值
  if (!isNaN(+item.maxValue) && +item.maxValue > 0) {
    ruleList.push({
      validator: (rule: any, value: any, callback: any) => {
        let tempValue = value.replace(/,/g, '') // 兼容金额
        if (!value) {
          callback()
        } else if (isNaN(+tempValue)) {
          callback(new Error(`${item.name}只能为数字`))
        } else if (+tempValue > +item.maxValue) {
          callback(new Error(`${item.name}最大值为${item.maxValue}`))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    })
  }
  // 数字 输入最小值
  if (!isNaN(+item.minValue) && +item.minValue > 0) {
    ruleList.push({
      validator: (rule: any, value: any, callback: any) => {
        let tempValue = value.replace(/,/g, '') // 兼容金额
        if (!value) {
          callback()
        } else if (isNaN(+tempValue)) {
          callback(new Error(`${item.name}只能为数字`))
        } else if (+tempValue < +item.minValue) {
          callback(new Error(`${item.name}最小值为${item.minValue}`))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    })
  }
  return ruleList
}

function isShowFieldTitle(data: Recordable) {
  const layout = isString(data.layout) ? JSON.parse(data.layout) : data.layout
  return !layout.hide
}

// 处理按钮
const showBtnList = ref<Recordable[]>([])
const moreBtnList = ref<Recordable[]>([])

onMounted(() => {
  if (props.moduleData.buttonList && props.moduleData.buttonList.length) {
    showBtnList.value = props.moduleData.buttonList.slice(0, 5)
    moreBtnList.value =
      props.moduleData.buttonList.length > 5 ? props.moduleData.buttonList.slice(5) : []
    console.log(showBtnList, 'showBtnList')
    console.log(moreBtnList, 'moreBtnList')
  }
})

const addVisible = ref(false)
const btnData = ref<Recordable>({})
const btnFormData = ref<Recordable>({})
function handleBtnClick(item: Recordable) {
  console.log(item, 'item22')
  const customerIdField = findFieldBySource(props.positions, '1743169758662483968')
  if (
    !isEmpty(customerIdField) &&
    (item.actionValue === 'da65ef166f384bf7a30415a01173f4' ||
      item.actionValue === 'e49c510abc8f4453863f0a7bce675f')
  ) {
    // 找到客户Id
    quoteDataIdListData.value = [props.formData[customerIdField.fieldCode]]
  }
  btnData.value = item
  if (item.actionCode === 'CREATOR_TABLE') {
    // 新增表单
    // 取出配置
    const extraSetting = item.extraSetting ? JSON.parse(item.extraSetting) : {}
    if (extraSetting.fieldDataList) {
      extraSetting.fieldDataList.forEach((item: Recordable) => {
        console.log(item, 'item1')
        if (item.type === 10) {
          btnFormData.value[item.leftFieldCode] = props.formData[item.rightFieldCode]
        }
        if (item.type === 20) {
          btnFormData.value[item.leftFieldCode] = item.rightValue
        }
        if (item.type === 30) {
          let val: any
          // 当前用户
          switch (item.rightValue) {
            case 10: // 当前用户
              console.log(accountStore.userInfo, 'accountStore')
              val = accountStore.userInfo.id
              break
            case 20: // 当前用户直级领导
              val = ''
              break
            case 30: // 当前用户所在部门
              val = accountStore.userInfo.departmentVO.id
              break
            case 40: // 当前日期
              val = formatToDate(new Date().getTime())
              break
            case 50: // 当前时间
              val = formatToDateTime(new Date().getTime())
              break
          }
          btnFormData.value[item.leftFieldCode] = val
        }
      })
      console.log(btnFormData, 'btnFormData')
    }
    addVisible.value = true
  }
  if (item.actionCode === 'OPEN_URL') {
    window.open(item.actionValue)
  }
}
function addSuccess() {
  addVisible.value = false
}
</script>
<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
  .btn-box {
    display: flex;
  }

  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}

.col-form-item-ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
  margin-top: 16px;

  > li {
    padding: 0 10px;
  }

  &.flex-col-1 {
    li {
      width: 100%;
    }
  }

  &.flex-col-2 {
    li {
      width: 50%;
    }
  }

  &.flex-col-3 {
    li {
      width: 33.33%;
    }
  }

  &.flex-col-4 {
    li {
      width: 25%;
    }
  }

  .col-item {
    &.col-1 {
      width: 25%;
    }

    &.col-2 {
      width: 33.33%;
    }

    &.col-3 {
      width: 50%;
    }

    &.col-4 {
      width: 66.66%;
    }

    &.col-5 {
      width: 75%;
    }

    &.col-6 {
      width: 100%;
    }

    .val {
      width: 100%;
    }
  }
}
</style>
